<template>
  <div>
    <div class="flex justify-between mb-4">
      <h2 class="text-2xl font-bold">Export Clients</h2>
      <base-button @click="addClientOpen = !addClientOpen">
        <span v-if="addClientOpen">Cancel</span>
        <span v-else><icon-plus /> Add new</span>
      </base-button>
    </div>

    <admin-export-client-form
      v-if="addClientOpen"
      @saved="addClientOpen = false"
      class="mb-8"
    />

    <admin-export-clients class="my-12" />
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from '@vue/composition-api';
import AdminExportClients from './components/AdminExportClients';
import AdminExportClientForm from './components/AdminExportClientForm.vue';

export default {
  components: {
    AdminExportClients,
    AdminExportClientForm,
  },
  setup(props, { root }) {
    const companyId = computed(() => root.$store.state.company.currentId);
    const addClientOpen = ref(false);

    watch(companyId, () => {
      root.$store.dispatch('company/exports/fetchExports');
    });
    onMounted(() => {
      root.$store.dispatch('company/exports/fetchExports');
    });

    return {
      addClientOpen,
    };
  },
};
</script>
